import { facebookTransitionEmailChangeService } from '../../service';
import { FB_AUTH_STATUS_CONNECTED } from './constants';
import { setFacebookSdkLoadingStart, setFacebookSdkLoadingEnd, setFacebookToken, setFacebookFetchToken, setFacebookFetchTokenEnd, setFacebookUserEmailUpdateFailed, } from './actions';
import { getFacebookAccessToken, getProvidedNewEmailByFacebookUser } from './selectors';
import { loadScript, asyncTryFinally, promisify } from './utils';
const isFacebookAppIdExist = (config) => { var _a; return !config || ((_a = config === null || config === void 0 ? void 0 : config.externalIds) === null || _a === void 0 ? void 0 : _a.facebook); };
const isFacebookSdkLoaded = (__window) => {
    return typeof __window.FB !== 'undefined';
};
const setFacebookTokenToStore = (dispatch, status, fbAccessToken) => {
    if (status === FB_AUTH_STATUS_CONNECTED) {
        dispatch(setFacebookToken(fbAccessToken));
    }
    else {
        dispatch(setFacebookToken(''));
    }
};
const getFacebookAccesstokenIdSessionExist = (_window, dispatch) => {
    _window.FB.getLoginStatus(response => {
        var _a;
        setFacebookTokenToStore(dispatch, response.status, (_a = response.authResponse) === null || _a === void 0 ? void 0 : _a.accessToken);
    });
};
export const createLoadFacebookSdk = (_loadingSdk, _loadingSdkEnded, _loadScript) => (__window, config) => (dispatch) => {
    try {
        const _window = __window;
        if (isFacebookSdkLoaded(_window)) {
            return;
        }
        if (!isFacebookAppIdExist(config)) {
            throw new Error('Facebook AppId configuration are not passed in component props.');
        }
        const { facebook } = config.externalIds;
        dispatch(_loadingSdk());
        _loadScript('https://connect.facebook.net/en_US/sdk.js');
        _window.fbAsyncInit = function () {
            _window.FB.init({
                appId: facebook,
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v3.1',
            });
            getFacebookAccesstokenIdSessionExist(_window, dispatch);
            dispatch(_loadingSdkEnded());
        };
    }
    catch (e) {
        console.log('Fail to load sdk!');
    }
};
export const loadFacebookSdk = createLoadFacebookSdk(setFacebookSdkLoadingStart, setFacebookSdkLoadingEnd, loadScript);
const fetchTokenLoaderWrapper = asyncTryFinally((dispatch) => dispatch(setFacebookFetchToken()), (dispatch) => dispatch(setFacebookFetchTokenEnd()));
const handleFacebookEmailUpdates = async (applicationState) => {
    try {
        const fbAccessToken = getFacebookAccessToken(applicationState);
        const email = getProvidedNewEmailByFacebookUser(applicationState);
        if (!fbAccessToken || !email) {
            return {
                error: 'invalid email or access token',
            };
        }
        const result = await facebookTransitionEmailChangeService({
            email,
            fbAccessToken,
        });
        return result;
    }
    catch (e) {
        console.log('Email update failed!');
    }
};
const isCustomerEnterDuplicateEmail = (result) => result && result.isExistingEmail;
const getFacebookLogInStatusAndAuthResponse = async (_window) => {
    const { status, authResponse } = await promisify(_window.FB.login)()({
        scope: 'email',
        auth_type: 'reauthenticate',
    });
    return { status, fbAccessToken: authResponse === null || authResponse === void 0 ? void 0 : authResponse.accessToken };
};
const isEmailSucessfullyUpdated = (result) => result && !!result.access_token;
export const fetchFacebookToken = (__window, handeResetPassword) => fetchTokenLoaderWrapper(async (dispatch, state) => {
    const _window = __window;
    if (!isFacebookSdkLoaded(_window)) {
        throw new Error('Facebook SDK missing');
    }
    const { status, fbAccessToken } = await getFacebookLogInStatusAndAuthResponse(_window);
    setFacebookTokenToStore(dispatch, status, fbAccessToken);
    const result = await handleFacebookEmailUpdates(state);
    if (isCustomerEnterDuplicateEmail(result)) {
        dispatch(setFacebookUserEmailUpdateFailed({
            isExistingEmail: true,
            authorizationFailedOrInvalidEmail: false,
        }));
    }
    else if (result && result.error) {
        dispatch(setFacebookUserEmailUpdateFailed({
            isExistingEmail: false,
            authorizationFailedOrInvalidEmail: true,
        }));
    }
    else if (isEmailSucessfullyUpdated(result)) {
        handeResetPassword();
    }
});
//# sourceMappingURL=helper.js.map